// extracted by mini-css-extract-plugin
export default {"warningContainer":"ScheduleTimeOff_warningContainer__lhR15","modalActions":"ScheduleTimeOff_modalActions__lfMWN"};